import { ApiSmpArtGallery, FailureApi } from "@smp/api";
import produce from "immer";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { useQueryPolotnoUserTemplates } from "@/queries";

type Params = Parameters<typeof ApiSmpArtGallery.Polotno.updateUserTemplate>[0];
type Response = Awaited<
  ReturnType<typeof ApiSmpArtGallery.Polotno.updateUserTemplate>
>;

const KEY = "USE_MUTATION_POLOTONO_USER_TEMPLATE_UPDATE";

export const useMutationPolotonoUserTemplateUpdate = (
  options?: UseMutationOptions<Response, FailureApi, Params>,
) => {
  const queryClient = useQueryClient();

  return useMutation(ApiSmpArtGallery.Polotno.updateUserTemplate, {
    ...options,
    mutationKey: KEY,
    onSuccess: (...args) => {
      const updatedTemplate = args[0];

      queryClient.setQueriesData<
        ReturnType<typeof useQueryPolotnoUserTemplates>["data"]
      >(
        useQueryPolotnoUserTemplates.KEY,
        (data) =>
          produce(data, (draft) => {
            if (draft?.pages) {
              draft?.pages.forEach((page) => {
                page.results = page.results.map((result) =>
                  result.id === updatedTemplate.id ? updatedTemplate : result,
                );
              });
            }
          }),
        {
          updatedAt: 0,
        },
      );

      options?.onSuccess?.(...args);
    },
  });
};

useMutationPolotonoUserTemplateUpdate.KEY = KEY;
